export default __webpack_public_path__ + "static/media/10.cf4f87e9.svg";